/* eslint-disable */
export const MARCHE = {
  lecture: { module: 'presse', element: 'marche', rule: 'lecture' },
  maj: { module: 'presse', element: 'marche', rule: 'maj' },
  exporter: { module: 'presse', element: 'marche', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'marche', rule: 'supprimer' },
};

export const LIEU_DE_LIVRAISON = {
  lecture: { module: 'achat', element: 'lieu_de_livraison', rule: 'lecture' },
  maj: { module: 'achat', element: 'lieu_de_livraison', rule: 'maj' },
  exporter: { module: 'achat', element: 'lieu_de_livraison', rule: 'exporter' },
  supprimer: { module: 'achat', element: 'lieu_de_livraison', rule: 'supprimer' },
};

export const FOURNISSEURS = {
  lecture: { module: 'achat', element: 'fournisseurs', rule: 'lecture' },
  maj: { module: 'achat', element: 'fournisseurs', rule: 'maj' },
  exporter: { module: 'achat', element: 'fournisseurs', rule: 'exporter' },
  supprimer: { module: 'achat', element: 'fournisseurs', rule: 'supprimer' },
};

export const COMMANDES = {
  lecture: { module: 'achat', element: 'commandes', rule: 'lecture' },
  maj: { module: 'achat', element: 'commandes', rule: 'maj' },
  exporter: { module: 'achat', element: 'commandes', rule: 'exporter' },
  editer: { module: 'achat', element: 'commandes', rule: 'edition' },
  supprimer: { module: 'achat', element: 'commandes', rule: 'supprimer' },
  editer: { module: 'achat', element: 'commandes', rule: 'edition' },
};

export const BON_RECEPTION = {
  lecture: { module: 'achat', element: 'bon_reception', rule: 'lecture' },
  maj: { module: 'achat', element: 'bon_reception', rule: 'maj' },
  exporter: { module: 'achat', element: 'bon_reception', rule: 'exporter' },
  supprimer: { module: 'achat', element: 'bon_reception', rule: 'supprimer' },
};

export const FACTURES = {
  lecture: { module: 'achat', element: 'factures', rule: 'lecture' },
  maj: { module: 'achat', element: 'factures', rule: 'maj' },
  exporter: { module: 'achat', element: 'factures', rule: 'exporter' },
  supprimer: { module: 'achat', element: 'factures', rule: 'supprimer' },
};

export const PAIEMENTS_FACTURES = {
  lecture: { module: 'achat', element: 'paiements_factures', rule: 'lecture' },
  maj: { module: 'achat', element: 'paiements_factures', rule: 'maj' },
  exporter: { module: 'achat', element: 'paiements_factures', rule: 'exporter' },
  supprimer: { module: 'achat', element: 'paiements_factures', rule: 'supprimer' },
};

export const LOT_PAIEMENTS_FACTURES = {
  lecture: { module: 'achat', element: 'lot_paiements_factures', rule: 'lecture' },
  maj: { module: 'achat', element: 'lot_paiements_factures', rule: 'maj' },
  exporter: { module: 'achat', element: 'lot_paiements_factures', rule: 'exporter' },
  supprimer: { module: 'achat', element: 'lot_paiements_factures', rule: 'supprimer' },
};

export const JOURNAL_PAIEMENTS_FACTURES = {
  lecture: { module: 'achat', element: 'journal_paiements_factures', rule: 'lecture' },
  maj: { module: 'achat', element: 'journal_paiements_factures', rule: 'maj' },
  exporter: { module: 'achat', element: 'journal_paiements_factures', rule: 'exporter' },
  supprimer: { module: 'achat', element: 'journal_paiements_factures', rule: 'supprimer' },
};
export const SUIVI_TACHES_INTERNES = {
  lecture: { module: 'achat', element: 'suivi_taches_internes', rule: 'lecture' },
  maj: { module: 'achat', element: 'suivi_taches_internes', rule: 'maj' },
  exporter: { module: 'achat', element: 'suivi_taches_internes', rule: 'exporter' },
  supprimer: { module: 'achat', element: 'suivi_taches_internes', rule: 'supprimer' },
};
